import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="character-counter"
export default class extends Controller {
  static get targets() { return ["input", "count", "max"]}

  initialize() {
    this.boundKeyup = this.keyup.bind(this);

    if (this.hasMaxTarget) {
      this.maxTarget.innerHTML = this.inputTarget.maxLength;
    }
    this.countTarget.innerHTML = this.inputTarget.value.length || '0';
    this.inputTarget.addEventListener("input", this.boundKeyup);
  }

  disconnect() {
    if (this.hasInputTarget && this.boundKeyup) {
      this.inputTarget.removeEventListener("input", this.boundKeyup);
    }
  }

  keyup(ev) {
    this.countTarget.innerHTML = ev.target.value.length;
  }
}
